import { render, staticRenderFns } from "./CustomDialogComponent.vue?vue&type=template&id=55c44715&scoped=true&lang=pug"
import script from "./CustomDialogComponent.vue?vue&type=script&lang=ts"
export * from "./CustomDialogComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomDialogComponent.vue?vue&type=style&index=0&id=55c44715&lang=scss&scoped=true"
import style1 from "./CustomDialogComponent.vue?vue&type=style&index=1&id=55c44715&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c44715",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c44715')) {
      api.createRecord('55c44715', component.options)
    } else {
      api.reload('55c44715', component.options)
    }
    module.hot.accept("./CustomDialogComponent.vue?vue&type=template&id=55c44715&scoped=true&lang=pug", function () {
      api.rerender('55c44715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/CustomDialog/CustomDialogComponent.vue"
export default component.exports